import React from 'react';

var BlocksContext = /*#__PURE__*/React.createContext({});
var BlocksContext$1 = BlocksContext;

export { BlocksContext$1 as default };
